import React, {useState , useEffect} from 'react';
import PageTitle from '../../components/PageTitle';
import genStyles from '../../styles/General.module.css'
import {useDisclosure } from '@mantine/hooks';
import {Button} from '@mantine/core';
import SorterList from './SorterList';
import {fakeSorterData} from '../../data/fakeData';
import SorterPopUp from './SorterPopUp';
import { SorterRowType , SorterAggrType, Belt} from '../../types/sorter';
import { useSorters } from '../../context/SorterContext';
import { useSorterOptions } from '../../context/SorterOptionsContext';
import { updateSorterOptions } from './SorterUtils';


const SorterPage = () =>{
    const [opened, { open, close }] = useDisclosure(false);
    const {sorters, aggrSorters, addSorter, deleteSorter} = useSorters();
    const {
    setCenterOptions,
    setFirmwareOptions,
    setColorModelOptions,
    setReuseModelOptions,
    setRecyclingModelOptions,
    } = useSorterOptions();

    useEffect(()=>{updateSorterOptions(setCenterOptions, setFirmwareOptions, setColorModelOptions, setReuseModelOptions, setRecyclingModelOptions)},[opened])
    
       
    const onSave = (sorter: SorterRowType[]) => {
        return addSorter(sorter)
    }

    const onDelete = (sorterId: number) =>{
        deleteSorter(sorterId)
    }

    //TODO: he puesto ceros no te tiene que dejar darle al save si no has completado los campos + beltID¿?
    return (
        <div>
            <SorterPopUp opened={opened} close={close} title="Add" edit={false} sorter={[{id:-1, name:"", center_id: -1, sorter_firmware_id: -1, sorter_color_model_id: -1, sorter_reuse_model_id: -1, sorter_recycling_model_id: -1, beltId:1, beltName:"",  num_hoppers:0}]} onSave={onSave} onDelete={onDelete}></SorterPopUp>
            <PageTitle title="Sorters"></PageTitle>
            <div className={genStyles.PageMain}>
                <SorterList aggrSorters={aggrSorters} sorters={sorters} onSave={onSave} onDelete={onDelete}></SorterList>
                <div className={genStyles.AddButtonWrapper}> 
                 <Button className ={genStyles.AddButton} onClick={open} variant="filled" color="#62929E" radius="xl">Add</Button>
              </div> 
            </div>
        </div>

    );
}

export default SorterPage   